import logo from "../images/usbank.svg";
import Elan from "../images/ElanP.png";
import {
  Grid,
  Box,
  IconButton,
  createTheme,
  adaptV4Theme,
  ThemeProvider,
  Button,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Link, useLocation, Routes, Route } from "react-router-dom";
import { toTitleCase } from "../utils";
import { isElanFsUser } from "../utils/auth";
import theme from "../utils/theme";
import { DashboardToolbarSelect } from "../pages/DashboardToolbarSelect";
import ProtectedRoute from "./ProtectedRoute";
import { USER_TYPE } from "../utils/constants";
import HelpIcon from "@mui/icons-material/Help";
import { UBPageSelect } from "../pages/UnionBank/UBPageSelect";
import { DownDetectorPageSelect } from "../pages/DownDetector/DownDetectorPageSelect";

const Header = ({ partner, isExternal }) => {
  const { pathname } = useLocation();
  const path = pathname.split("/").filter((x) => x);
  const pathHeader = pathname.includes("fidelity");
  const darkTheme = createTheme(adaptV4Theme({ palette: { mode: "dark" } }));

  return (
    <AppBar position="fixed" color={isElanFsUser() ? "secondary" : "primary"}>
      <Toolbar>
        <Box sx={{ mr: 2 }}>
          {isElanFsUser() ? (
            <img src={Elan} alt="ELAN" width="82" height="38" />
          ) : (
            <img src={logo} alt="U.S. Bank" width="117" height="60" />
          )}
        </Box>

        <Breadcrumbs
          aria-label="breadcrumb"
          separator={
            <Typography variant="h6" sx={{ color: "common.white" }}>
              /
            </Typography>
          }
          sx={{ flexGrow: 1 }}
        >
          {path.map((route, index) =>
            index === path.length - 1 || route === "unionbank" ? (
              <Typography
                variant="h6"
                key={route}
                sx={{ color: "common.white" }}
                data-testid="route"
              >
                {route === "unionbank" ? "Union Bank" : route.toUpperCase()}
              </Typography>
            ) : (
              <Typography
                variant="h6"
                key={route}
                sx={{ color: "common.white" }}
                data-testid="route"
              >
                <Link
                  key={route}
                  to={`/${path.slice(0, index + 1).join("/")}`}
                  style={{ color: "white" }}
                  data-testid="route"
                >
                  {route === "unionbank" ? "Union Bank" : index === 1 ? route.toUpperCase() : toTitleCase(route)}
                </Link>
              </Typography>
            )
          )}
        </Breadcrumbs>

        {isExternal && (
          <Routes>
            <Route
              path="/:partner/:dashboard"
              element={
                <Box>
                  <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                    <DashboardToolbarSelect />
                  </ProtectedRoute>
                </Box>
              }
            />
            <Route
              path="/:partner/:dashboard/realtime/:date"
              element={
                <Box>
                  <ProtectedRoute roles={[USER_TYPE.AUTHENTICATED]}>
                    <DashboardToolbarSelect />
                  </ProtectedRoute>
                </Box>
              }
            />
          </Routes>
        )}

        {!isExternal && (
          <Routes>
            <Route path="/unionbank/:dashboard/*" element={<UBPageSelect />} />
            <Route
              path="/downdetector/*"
              element={<DownDetectorPageSelect />}
            />
          </Routes>
        )}

        {!isExternal &&
          path?.[0] !== "unionbank" &&
          path?.[0] !== "log" &&
          path?.[0] !== "downdetector" && (
            <Typography variant="subtitle2">
              <a
                // className={""}
                target="_blank"
                href="/api/prod-support/dashboard"
                rel="noreferrer"
              >
                Incidents
              </a>
            </Typography>
          )}

        {!isExternal && path?.[0] === "unionbank" && (
          <ThemeProvider theme={darkTheme}>
            {/* <a href={supportPdf} without rel="noopener noreferrer" target="_blank">
                <IconButton href={supportPdf} without rel="noopener noreferror" target="_blank" aria-label="upload picture" component="label">
                    <HelpIcon/>
                </IconButton>
              </a> */}
          </ThemeProvider>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
